import React from "react";

const faqs = [
  {
    faqTitle: "What is no-code development?",
    faqDescription:
      "No-code development allows you to build applications and websites without writing traditional code, using visual tools and platforms.",
  },
  {
    faqTitle: "Is no-code scalable?",
    faqDescription:
      "Yes, for most business use cases. But if you’re building the next Facebook, you’ll eventually need custom code.",
  },
  {
    faqTitle: "How fast can a project be built?",
    faqDescription:
      "Days or weeks instead of months. That’s literally the point.",
  },
  {
    faqTitle: "Is no-code secure?",
    faqDescription:
      "Security depends on the platform and implementation. Reputable tools follow industry standards.",
  },
  {
    faqTitle: "Can no-code replace developers?",
    faqDescription:
      "No. It removes grunt work. Developers still handle complex logic, integrations, and scaling.",
  },
  {
    faqTitle: "What platforms do you use?",
    faqDescription:
      "Tools like Webflow, Bubble, Airtable, and automation platforms depending on the project needs.",
  },
];

const NoCodeFaq = () => {
  return (
    <section className="app-faq sub-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="content md-mb50">
              <h2 className="mb-30 text-center">
                Frequently Asked Questions
              </h2>
            </div>
          </div>

          {/* Column 1 */}
          <div className="col-lg-6">
            <div className="accordion" id="accordionColumn1">
              {faqs.slice(0, 3).map((faq, i) => (
                <div className="card" key={i}>
                  <div className="card-header" id={`heading${i}`}>
                    <h2 className="mb-0">
                      <button
                        className="btn btn-link btn-block text-left"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse${i}`}
                        aria-expanded={i === 0}
                        aria-controls={`collapse${i}`}
                      >
                        <div className="title">
                          <h6 className="faqt">{faq.faqTitle}</h6>
                        </div>
                      </button>
                    </h2>
                  </div>

                  <div
                    id={`collapse${i}`}
                    className="collapse"
                    aria-labelledby={`heading${i}`}
                    data-parent="#accordionColumn1"
                  >
                    <div className="card-body">
                      {faq.faqDescription}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Column 2 */}
          <div className="col-lg-6">
            <div className="accordion" id="accordionColumn2">
              {faqs.slice(3, 6).map((faq, i) => (
                <div className="card" key={i + 3}>
                  <div className="card-header" id={`heading${i + 3}`}>
                    <h2 className="mb-0">
                      <button
                        className="btn btn-link btn-block text-left"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse${i + 3}`}
                        aria-expanded={i === 0}
                        aria-controls={`collapse${i + 3}`}
                      >
                        <div className="title">
                          <h6 className="faqt">{faq.faqTitle}</h6>
                        </div>
                      </button>
                    </h2>
                  </div>

                  <div
                    id={`collapse${i + 3}`}
                    className="collapse"
                    aria-labelledby={`heading${i + 3}`}
                    data-parent="#accordionColumn2"
                  >
                    <div className="card-body">
                      {faq.faqDescription}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NoCodeFaq;
